module.exports = __webpack_public_path__ + "static/media/cq_grafico_torta.e2e3457c.svg";